import { LineStyle } from 'lightweight-charts'
import { CanvasSettings } from '../components/chartV2/chart.typings'

/** 4th option in line style picker: solid, dotted, dashed, large_dashed, sparse_dotted */
export const DEFAULT_CROSSHAIR_LINE_STYLE = 'large_dashed' as const

export const defaultCanvasSettings: Required<
    Pick<
        CanvasSettings,
        | 'gridVisibility'
        | 'gridHorzColor'
        | 'gridHorzColorOpacity'
        | 'gridVertColor'
        | 'gridVertColorOpacity'
        | 'crosshairColor'
        | 'crosshairColorOpacity'
        | 'crosshairThickness'
        | 'crosshairLineStyle'
        | 'scaleTextColor'
        | 'scaleTextColorOpacity'
        | 'scaleTextFontSize'
        | 'scaleLinesColor'
        | 'scaleLinesColorOpacity'
    >
> = {
    gridVisibility: 'both',
    gridHorzColor: '#888888',
    gridHorzColorOpacity: 0.08,
    gridVertColor: '#888888',
    gridVertColorOpacity: 0.08,
    crosshairColor: '#888888',
    crosshairColorOpacity: 0.8,
    crosshairThickness: 1,
    crosshairLineStyle: DEFAULT_CROSSHAIR_LINE_STYLE,
    scaleTextColor: '#888888',
    scaleTextColorOpacity: 1,
    scaleTextFontSize: 12,
    scaleLinesColor: '#888888',
    scaleLinesColorOpacity: 0.06,
}

export const canvasLineStyleToLineStyle = (style: CanvasSettings['crosshairLineStyle']): LineStyle => {
    switch (style) {
        case 'solid':
            return LineStyle.Solid
        case 'dotted':
            return LineStyle.Dotted
        case 'dashed':
            return LineStyle.Dashed
        case 'large_dashed':
            return LineStyle.LargeDashed
        case 'sparse_dotted':
            return LineStyle.SparseDotted
        default:
            return LineStyle.LargeDashed
    }
}

export const mergeCanvasSettings = (settings?: CanvasSettings): typeof defaultCanvasSettings =>
    ({ ...defaultCanvasSettings, ...settings })
